import types from '../types'
import Action from '../../types/Action'

const initialState = {
  loading: true,
  error: false,
  success: false,
  data: []
}

const transportationReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.GET_TRANSPORTATION_REQUESTED: {
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        data: []
      }
    }
    case types.GET_TRANSPORTATION_FULFILLED: {
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload
      }
    }
    case types.GET_TRANSPORTATION_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default transportationReducer